/** Paint no page background while a compositing canvas is open, and restore it on the way out. */

import { useEffect } from "react";

export function useTransparentCanvas(): void {
  useEffect(() => {
    const root = document.documentElement;
    const previous = root.dataset.canvas;
    root.dataset.canvas = "transparent";
    return () => {
      if (previous === undefined) delete root.dataset.canvas;
      else root.dataset.canvas = previous;
    };
  }, []);
}
